import { RouterStateSnapshot } from '@angular/router';

const ORGANIZATION_DETAILS_TAB_URL_PATTERN = /^\/(?:organization\/details\/[^/]+|[^/]+\/details\/[^/]+)$/;

function normalizeUrl(url: string): string {
    return url.split('?')[0].split('#')[0];
}

export function isOrganizationDetailsTabNavigation(currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): boolean {
    const current = normalizeUrl(currentState.url);
    const next = normalizeUrl(nextState.url);

    if (!ORGANIZATION_DETAILS_TAB_URL_PATTERN.test(current) || !ORGANIZATION_DETAILS_TAB_URL_PATTERN.test(next)) {
        return false;
    }

    const currentBase = current.substring(0, current.lastIndexOf('/'));
    const nextBase = next.substring(0, next.lastIndexOf('/'));

    return currentBase === nextBase && current !== next;
}

export function isInnerTabAllowedWithChangesNavigation(currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): boolean {
    return isOrganizationDetailsTabNavigation(currentState, nextState);
}
